<template>
  <div class="userinfo-main">
    <div class="info-box">
      <div class="info-item head-item border">
        <div>微信头像</div>
        <div class="info-img">
          <img :src="infoData.HeadPortraitUrl" alt="" />
        </div>
      </div>
      <div class="info-item border">
        <div>微信昵称</div>
        <div class="info-txt">{{ infoData.Nick || '----' }}</div>
      </div>
      <div class="info-item">
        <div>搜货会员名</div>
        <div class="info-txt">{{ infoData.LoginName || '无' }}</div>
      </div>
    </div>
    <div class="info-box m-top">
      <div class="info-item border" @click="editPlatformNumber">
        <div>淘宝号</div>
        <div class="info-txt">{{ infoData.PlatformNumber || '无' }}<i class="iconfont icon-xiangzuo1"></i></div>
      </div>
      <div class="info-item" @click="editPhone">
        <div>手机号</div>
        <div class="info-txt">{{ infoData.LoginName || '无' }}<i class="iconfont icon-xiangzuo1"></i></div>
      </div>
    </div>
  </div>
</template>

<script>
import userInfo from './mixins/index'
export default {
  name: 'userInfo',
  mixins: [userInfo]
}
</script>

<style lang="scss" scoped>
@import './css/index.scss';
</style>
